import { defineMessages } from 'react-intl';

const translations = {
  breadcrumbs: {
    integrations: {
      id: 'pages.viewIntegration.breadcrumbs.integrations',
      defaultMessage: 'Integrations',
      description: 'Label of the integrations breadcrumb on the integration view',
    },
  },
  subNavigation: {
    details: {
      id: 'pages.viewIntegration.subNavigation.details',
      defaultMessage: 'Details',
      description: 'Label of the details sub navigation on the integration view',
    },
    logs: {
      id: 'pages.viewIntegration.subNavigation.logs',
      defaultMessage: 'Logs',
      description: 'Label of the logs sub navigation on the integration view',
    },
  },
  primaryAction: {
    label: {
      id: 'actions.edit',
      defaultMessage: 'Edit',
      description: 'Label of the primary action on the integration view',
    },
  },
  secondaryActions: {
    deleteIntegration: {
      id: 'actions.delete',
      defaultMessage: 'Delete',
      description: 'Label of the secondary action delete on the integration view',
    },
  },
  unknownIntegration: {
    title: {
      id: 'pages.viewIntegration.unknownIntegration.title',
      defaultMessage: 'Unknown integration',
      description: 'Title of the page when integration is unknown',
    },
    message: {
      id: 'pages.viewIntegration.unknownIntegration.message',
      defaultMessage: 'This integration does not exist',
      description: 'Message when an invalid integration is given',
    },
  },
  confirmDeleteIntegration: {
    title: {
      id: 'confirmDeleteIntegration.title',
      defaultMessage: 'Delete integration',
      description: 'Title of the confirm delete integration dialog',
    },
    description: {
      id: 'confirmDeleteIntegration.description',
      defaultMessage: 'Are you sure you would like to delete this integration?',
      description: 'Description of the confirm delete integration dialog',
    },
    buttons: {
      cancel: {
        id: 'actions.cancel',
        defaultMessage: 'Cancel',
        description: 'Label of the cancel button in the delete integration dialog',
      },
      delete: {
        id: 'actions.delete',
        defaultMessage: 'Delete',
        description: 'Label of the delete button in the delete integration dialog',
      },
    },
  },
  feedback: {
    integrationDeleted: {
      id: 'confirmDeleteIntegration.feedback.integrationDeleted',
      defaultMessage: 'Integration deleted',
      description: 'Success message of the delete integration action',
    },
    integrationNotDeleted: {
      id: 'confirmDeleteIntegration.feedback.integrationNotDeleted',
      defaultMessage: 'Integration could not be deleted',
      description: 'Error message of the delete integration action',
    },
  },
};

export default defineMessages(translations);
